<lib-panel-menu
  #panelmenu
  styleClass="screenMenu"
  [multiple]="false"
  [(model)]="screenList"
  [style]="{ width: '100%' }"
  #screenMenu
></lib-panel-menu>



